import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
}
export const Root = styled.div`
  font-family: Roboto;
  margin-top:6px;
  padding: 0px 4px;
`;

export const ButtonContainer = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${C.WHITE};
  display:flex;
  width: 36px;
  height: 31px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
      background-color: ${C.GRAY}
    }
`;